"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateOrganisationRequestStruct = void 0;
const superstruct_1 = require("superstruct");
exports.UpdateOrganisationRequestStruct = (0, superstruct_1.type)({
    id: (0, superstruct_1.string)(),
    name: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    imageStoragePath: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    streetAddress: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    postalCode: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    referralCode: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    city: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    country: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    vatId: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    industry: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    stripeCustomerId: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    referalCode: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    pocUserIds: (0, superstruct_1.optional)((0, superstruct_1.array)((0, superstruct_1.string)())),
});
//# sourceMappingURL=UpdateOrganisationRequest.js.map